import { ObservableModelNode } from "../observable";
import {
  createImageUrlAutoFormField,
  type SpecsAutoFormFieldMetadataMap,
} from "../autoFormMetadata";
import { cloneValue, expectObject, readString, splitKnown } from "../utils";

export class DecorationDesignTemplateModel extends ObservableModelNode {
  static autoFormFields: SpecsAutoFormFieldMetadataMap = {
    name: { label: "Name", fieldType: "text" },
    url: createImageUrlAutoFormField({ label: "URL" }),
    extra: { label: "Extra JSON", fieldType: "json", minRows: 4 },
  };

  name!: string;
  url!: string;
  extra!: Record<string, unknown>;

  constructor() {
    super();
    this.defineObservableValue("name", "");
    this.defineObservableValue("url", "");
    this.defineObservableValue("extra", {});
  }

  restore(snapshot: unknown) {
    const source = expectObject(snapshot, "decoration design template");
    this.name = readString(source, "name");
    this.url = readString(source, "url");
    this.extra = splitKnown(source, ["name", "url"]);
    return this;
  }

  save() {
    return {
      ...cloneValue(this.extra),
      ...(this.name ? { name: this.name } : {}),
      ...(this.url ? { url: this.url } : {}),
    };
  }
}
